import "./styles.scss";

import { Modal } from "./components";
import useMostSearched from "./useMostSearched";

import { useFaq } from "context/client/faq";
import useResponsive from "libs/helpers/useResponsive";

const mainClass = "faq-most-searched";

const MostSearched = () => {
  const { max } = useResponsive();

  const { setSelected } = useFaq();
  const { data, shuffledIndices, MAX_ITEMS } = useMostSearched();

  return (
    <div className={mainClass}>
      {shuffledIndices
        .slice(0, max.sm ? MAX_ITEMS : max.lg ? 5 : MAX_ITEMS - 1)
        .map((index) => {
          const item = data[index];

          if (!item) return null;

          const slug = item.category.slug;
          const category = {
            label: item.category.title,
            color:
              slug === "payments-and-subscriptions"
                ? "blue"
                : slug === "referral-program"
                  ? "green"
                  : "yellow",
          };

          return (
            <button
              key={index}
              type="button"
              onClick={() =>
                setSelected({
                  title: item.title,
                  category,
                  content: item.content,
                })
              }
            >
              {item?.title}
            </button>
          );
        })}
    </div>
  );
};

MostSearched.Modal = Modal;

export default MostSearched;
